import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { getProductNames, getCustomerNames, getDSNames, getProductGroupNames,  getCustomerGroupNames} from "./scenarioApprovalUtils";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function ScenarioDetails() {
   const state = useSelector((store) => store.scenarioApproval);
   const { scenarioDetails } = state;

   if (scenarioDetails === null) {
      return null;
   }

   const {
      scenarioName,
      effectiveStartDate,
      effectiveEndDate,
      product,
      customers,
      scenarioDatasource,
      customerBreakdown,
      linearFCTimePeriod,
      runRateTimePeriod,
      financialFCTimePeriod,
      productGroup,
      customerGroups
   } = scenarioDetails;

   const period = `${new Date(effectiveStartDate).toLocaleDateString("en-UK",{
      year:'numeric',
      month:'2-digit',
      day:'2-digit'
   }).split("T")[0]} - ${
      new Date(effectiveEndDate).toLocaleDateString("en-UK",{
         year:'numeric',
         month:'2-digit',
         day:'2-digit'
      }).split("T")[0]
   }`;
   const productNames = getProductNames(product);
   const customerNames = getCustomerNames(customers);
   const productGroupNames = getProductGroupNames(productGroup);
   const customerGroupNames = getCustomerGroupNames(customerGroups);
   const dsNames = getDSNames(scenarioDatasource);
   return (
      <Box  sx={{mt: 2,}}>
         {/* <Typography
            variant="subtitle1"
            gutterBottom
            sx={{ fontWeight: "bold", mt: 4, width:"100%" }}
            className="compHeading"
         >
            Scenario Details
         </Typography> */}
      <CollapseSection title="Scenario Details">
         <Box
            sx={{
               fontSize: "14px",
            }}
         >
            <LabelValue label={"Scenario Of"} value={scenarioName} />
            <LabelValue label={"Scenario Name"} value={scenarioName} />
            <LabelValue label={"Validity Period"} value={period} />
            <LabelValue label={"Customer Breakdown"} value={customerBreakdown} />
            {/* <LabelValue label={"Linear FC Time Period"} value={linearFCTimePeriod} />
            <LabelValue label={"Run Rate Time Period"} value={runRateTimePeriod} />
            <LabelValue label={"Financial FC Time Period"} value={financialFCTimePeriod} /> */}
            <Box>
					<Typography sx={{ fontWeight: "600", fontSize: "14px", }} display="inline">
                  Product Groups(s): {" "}
					</Typography>
					<Typography display="inline" sx={{fontSize: "14px"}}>{productGroupNames.join(', ')}</Typography>
				</Box>
            <Box>
					<Typography sx={{ fontWeight: "600", fontSize: "14px" }} display="inline">
                  SKU(s): {" "}
					</Typography>
					<Typography display="inline" sx={{fontSize: "14px"}}>{productNames.join(', ')}</Typography>
				</Box>
            <Box>
					<Typography sx={{ fontWeight: "600", fontSize: "14px" }} display="inline">
                  Customer Groups(s): {" "}
					</Typography>
					<Typography display="inline" sx={{fontSize: "14px"}}>{customerGroupNames.join(', ')}</Typography>
				</Box>
            <Box>
					<Typography sx={{ fontWeight: "600", fontSize: "14px" }} display="inline">
                  Customer(s): {" "}
					</Typography>
					<Typography display="inline" sx={{fontSize: "14px"}}>{customerNames.join(', ')}</Typography>
				</Box>
            <Box mb={3}>
					<Typography sx={{ fontWeight: "600", fontSize: "14px" }} display="inline">
                  Data Source(s): {" "}
					</Typography>
					<Typography display="inline" sx={{fontSize: "14px"}}>{dsNames.join(', ')}</Typography>
				</Box>
         </Box>
      </CollapseSection>
      </Box>
   );
}

function LabelValue({ label, value }) {
   return (
      <div>
         <strong>{label}:</strong>&nbsp;{value}
      </div>
   );
}

function UnorderedList({ label, values }) {
   return (
      <>
         <Typography sx={{ mt:2, fontWeight: "bold" }}>{label}:</Typography>
         <Box
            sx={{ 
               width: 500,
               height: 100,
               border: 1,
               overflow: "auto",
            }}
         >
            <List dense={true}>
               {values.length > 0
                  ? values.map((item, index) => {
                       return (
                          <ListItem key={index}>
                             <ListItemText>{item}</ListItemText>
                          </ListItem>
                       );
                    })
                  : "No items."}
            </List>
         </Box>
      </>
   );
}
